import { useQuery } from "react-query";

import { pullAllFromPouch } from "./queryFn";

export const useGet = (key: string[], localDBPathName: string) => {
  return useQuery(key, () => pullAllFromPouch(localDBPathName));
};
